import request from '@/utils/request.js'

// 获取车辆列表
export const getCars = (data) => {
  return request({
    url: '/cloud/carInfoEntity/selectPageList',
    method: 'post',
    data: data
  })
}

// 添加车辆
export const addCar = (data) => {
  return request({
    url: '/cloud/carInfoEntity/insertOne',
    method: 'post',
    data: data
  })
}

// 编辑车辆
export const editCar = (data) => {
  return request({
    url: '/cloud/carInfoEntity/editOne',
    method: 'post',
    data: data
  })
}

// 测试牌照变更
export const changeCarTestNum = (data) => {
  return request({
    url: '/cloud/carInfoEntity/change',
    method: 'post',
    data: data
  })
}

//测试牌照变更
export const carTestNumChangeList = (carId) => {
  return request({
    url: '/cloud/carInfoEntity/changeList?carId=' + carId,
    method: 'get',
  })
}

// 获取车辆详情
export const getCarDetail = (data) => {
  return request({
    url: '/cloud/carInfoEntity/detail',
    method: 'post',
    data: data
  })
}

// 获取车辆详情-编辑
export const detailById = (data) => {
  return request({
    url: '/cloud/carInfoEntity/detailById',
    method: 'post',
    data: data
  })
}

// 删除车辆
export const delCars = (data) => {
  return request({
    url: '/cloud/carInfoEntity/deleteBatch',
    method: 'post',
    data: data
  })
}

// 修改车辆状态
export const updateStatus = (data) => {
  return request({
    url: '/cloud/carInfoEntity/updateStatus',
    method: 'post',
    data: data
  })
}

// 查看车辆信息变更申请
export const checkByCarId = (data) => {
  return request({
    url: '/cloud/carChangeApplyEntity/checkByCarId',
    method: 'post',
    data: data
  })
}

// 新增车辆信息变更申请
export const addCarChangeApply = (data) => {
  return request({
    url: '/cloud/carChangeApplyEntity/insertOne',
    method: 'post',
    data: data
  })
}

//撤销车辆信息变更申请
export const withdrawCarChangeApply = (data) => {
  return request({
    url: '/cloud/carChangeApplyEntity/withdraw',
    method: 'post',
    data: data
  })
}

//车辆统计
export const carCount = () => {
  return request({
    url: '/cloud/carInfoEntity/count',
    method: 'get'
  })
}

//车辆类型统计
export const carTypeCount = () => {
  return request({
    url: '/cloud/carInfoEntity/carTypeCount',
    method: 'get'
  })
}

//牌照统计
export const plateCount = () => {
  return request({
    url: '/cloud/carInfoEntity/plateCount',
    method: 'get'
  })
}

export const getAllCarTaskAccumulatedMileage = () => {

  return request({
    url: '/monitorPlat/dashboard/getAllCarTaskAccumulatedMileage',
    method: 'get'
  })
}